import { NONE } from '@festina-life/api'
import { Alert, FullscreenSpinner } from '@festina-life/ui/feedback'
import { Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { Navigate, Route, Routes } from 'react-router'

import { AnnulOperationDetailView } from '../scenes/annulOperation/AnnulOperationDetailView'
import { EnumViewer } from '../scenes/enum/EnumViewer'
import { GlMapViewer } from '../scenes/glMap/GlMapViewer'
import { MainLayout } from '../scenes/layout/MainLayout'
import { ParameterDefinition } from '../scenes/parameter/ParameterDefinition'
import { ReconciliationSpecViewer } from '../scenes/reconciliationSpec/ReconciliationSpecViewer'
import { ScratchpadRoute } from '../scenes/scratchpad/ScratchpadRoute'
import { TemplateViewer } from '../scenes/template/templateViewer/TemplateViewer'
import { TenantViewer } from '../scenes/tenant/TenantViewer'
import {
  DEFAULT_BLOCK,
  NO_LAYER_PATH,
  READ_ONLY_WORKSPACE,
  SHARED_TENANT_PATH,
} from './constants'
import { RouteProvider } from './RouteProvider'
import { useAvailableServersForConfiguration } from './useAvailableServersForConfiguration'

/** Page router for the configuration portal. */
export const Router = () => {
  const configuredServers = useAvailableServersForConfiguration()
  const defaultServer = configuredServers.includes('life')
    ? 'life'
    : configuredServers[0]

  return (
    <ErrorBoundary
      fallback={
        <Alert severity="error">An error occurred loading the page</Alert>
      }
    >
      <Suspense fallback={<FullscreenSpinner />}>
        <Routes>
          <Route path=":server">
            <Route path=":branch">
              <Route path=":workspaceName">
                <Route path=":block">
                  <Route path=":layerId">
                    <Route path=":tenantId">
                      <Route element={<RouteProvider />}>
                        <Route path="" element={<MainLayout />}>
                          <Route
                            path="scratchpad"
                            element={<ScratchpadRoute />}
                          />
                          <Route
                            path="template/:templateId"
                            element={<TemplateViewer />}
                          />
                          <Route
                            path="parameter/:parameterDefinitionId"
                            element={<ParameterDefinition />}
                          />
                          <Route path="enum/:enumId" element={<EnumViewer />} />
                          <Route
                            path="glMap/:mappingId"
                            element={<GlMapViewer />}
                          />
                          <Route
                            path="reconciliationSpec/:specId"
                            element={<ReconciliationSpecViewer />}
                          />
                          <Route
                            path="registeredTenant/:registeredTenantId"
                            element={<TenantViewer />}
                          />
                          <Route
                            path="annulOperation/:annulOperationKey"
                            element={<AnnulOperationDetailView />}
                          />
                        </Route>
                      </Route>
                    </Route>
                    <Route
                      path=""
                      element={<Navigate to={SHARED_TENANT_PATH} />}
                    />
                  </Route>
                  <Route path="" element={<Navigate to={NO_LAYER_PATH} />} />
                </Route>
                <Route path="" element={<Navigate to={DEFAULT_BLOCK} />} />
              </Route>
              <Route path="" element={<Navigate to={READ_ONLY_WORKSPACE} />} />
            </Route>
            <Route path="" element={<Navigate to={NONE} />} />
          </Route>
          <Route path="" element={<Navigate to={defaultServer} />} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  )
}
